import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always dark mode - no state needed
  const isDark = true;

  useEffect(() => {
    // Always apply dark theme to document root
    document.documentElement.classList.add('dark');
    // Clean up any saved theme preference since we're always dark now
    localStorage.removeItem('gamepicker-theme');
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};